import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker to enable PWA / offline support.
// When an update is available a banner will prompt the user to refresh.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New version available — show a toast/banner nudging the user to refresh
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    const bar = document.createElement('div');
    bar.innerHTML = `
      <div style="
        position:fixed; bottom:80px; left:50%; transform:translateX(-50%);
        background:#3b82f6; color:#fff; padding:12px 20px; border-radius:12px;
        font-family:Inter,sans-serif; font-size:14px; font-weight:600;
        box-shadow:0 4px 20px rgba(0,0,0,0.35); z-index:9999;
        display:flex; align-items:center; gap:12px; white-space:nowrap;
      ">
        🔄 New version available!
        <button onclick="window.location.reload()" style="
          background:rgba(255,255,255,0.2); border:none; color:#fff;
          padding:5px 12px; border-radius:8px; cursor:pointer; font-size:13px; font-weight:600;
        ">Refresh</button>
      </div>`;
    document.body.appendChild(bar);
    setTimeout(() => bar.remove(), 12000);
  },
  onSuccess: () => {
    console.log('[WayMatch] App cached for offline use.');
  },
});
